import { jsx as _jsx } from "react/jsx-runtime";
import React, { Component } from 'react';
import CommitStatusIcon from '../components/CommitStatusIcon';
export class CommitStatusBadge extends Component {
    render() {
        const { commitOptions, isCommitDone, isCommitTimedOut, isCommitMeetingThreshold, errorCount, warningCount, loading } = this.props;
        return loading ? null : (_jsx(CommitStatusIcon, { commitOptions: commitOptions, isCommitDone: isCommitDone, isCommitTimedOut: isCommitTimedOut, isCommitMeetingThreshold: isCommitMeetingThreshold, className: "p-1" }));
    }
}
export default CommitStatusBadge;
